// import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Back1 from '../assets/images/back-home-1.webp';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import CobranzaPage from '../pages/CobranzaPage';

export const Cobranza = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t('Solucion de Cobranza eficiente para entidades financieras')}
        description={t('Mejora la recuperación de cartera con un sistema de cobranza automatizado y flexible, adaptado a tus necesidades operativas y estratégicas.')}
        bolImage={false}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/collections' : 'cobranza'}`}
        hreflang={[
          { url: "https://dynamicore.io/cobranza", lang: "es" },
          { url: "https://dynamicore.io/en/collections", lang: "en-us" }
        ]}
      />
      <CobranzaPage/>
    </Layout>
  )
}


// export const Cobranza = () => {
//   const { t, i18n } = useTranslation();

//   const metaCia = 'Dynamicore';
//   const metaUrl = '';
//   const metaTwitterSite = '';
//   const metaTwitterCreator = '';

//   const title = '';
//   const description = '';
//   const lang = 'es_MX';
//   const meta = {};
//   const onlytitle = false;

//   //const metaOgImage      = bolImage ? metaUrl + '/images/metas/' + 'beneficios_f.jpg' : 'beneficios_f.jpg';
//   //const metaTwitterImage = bolImage ? metaUrl + '/images/metas/' + 'beneficios_t.jpg' : 'beneficios_t.jpg';

//   return (
//     <Layout backgroundimage={Back1} actionDemo={false}>
//       {/*<SEO
//         //title="Cobranza"
//         //description="Automatiza procesos financieros"
//         //works='Core Financiero, Fintech, Onboarding digital, Aprobación de crédito, Gestión de cobranza, Análisis de crédito, Core Bancario, Automatización de procesos, Procesos digitales, Producto financiero, Servicios financieros, Digitalización de procesos, Software financiero, Dispersión, Reportes automatizados, Corebanking, Sector financiero, SOFIPO, SOFOM, CNBV, Condusef, Servicios financieros digitales, Plataforma financiera'
//         bolImage={false}
//         ogImage={`beneficios_f.jpg`}
//         //twitterImage={`beneficios_t.jpg`}
//         //canonicalUrl="https://dynamicore.io/cobranza"
//       />*/}

//       <Helmet
//         htmlAttributes={{
//           lang,
//         }}
//         title={
//           onlytitle
//             ? t(`Gestión de Cobranza Eficiente para Instituciones Financieras`)
//             : t(
//                 `Gestión de Cobranza Eficiente para Instituciones Financieras | ${metaCia}`
//               )
//         }
//         titleTemplate={
//           onlytitle
//             ? t(`Gestión de Cobranza Eficiente para Instituciones Financieras`)
//             : t(
//                 `Gestión de Cobranza Eficiente para Instituciones Financieras | ${metaCia}`
//               )
//         }
//         meta={[
//           {
//             name: `description`,
//             content: 'Cobranza',
//           },
//           {
//             name: `robots`,
//             content: 'all',
//           },
//           {
//             name: `lang`,
//             content: 'es',
//           },
//           {
//             property: `keywords`,
//             content:
//               'Core Financiero, Fintech, Onboarding digital, Aprobación de crédito, Gestión de cobranza, Análisis de crédito, Core Bancario, Automatización de procesos, Procesos digitales, Producto financiero, Servicios financieros, Digitalización de procesos, Software financiero, Dispersión, Reportes automatizados, Corebanking, Sector financiero, SOFIPO, SOFOM, CNBV, Condusef, Servicios financieros digitales, Plataforma financiera',
//           },
//           {
//             property: `og:title`,
//             content: `${title} | ${metaCia}`,
//           },
//           {
//             property: `og:description`,
//             content: description,
//           },
//           {
//             property: `og:type`,
//             content: `website`,
//           },
//           {
//             property: `og:site_name`,
//             content: `${title} | ${metaCia}`,
//           },
//           {
//             property: `og:url`,
//             content: metaUrl,
//           },
//           {
//             property: `og:local`,
//             content: 'en_US',
//           },
//           {
//             name: `twitter:card`,
//             content: `summary`,
//           },
//           {
//             name: `twitter:title`,
//             content: `${title} | ${metaCia}`,
//           },
//           {
//             name: `twitter:description`,
//             content: description,
//           },
//           {
//             name: `twitter:url`,
//             content: metaUrl,
//           },
//           {
//             name: `twitter:site`,
//             content: metaTwitterSite,
//           },
//           {
//             name: `twitter:creator`,
//             content: metaTwitterCreator,
//           },
//         ].concat(meta)}
//       >
//         <meta
//           name="description"
//           content={t('Automatiza procesos financieros')}
//         />
//         <meta
//           name="keywords"
//           content={[
//             t('Core Financiero'),
//             t('Fintech'),
//             t('Onboarding digital'),
//             t('Aprobación de crédito'),
//             t('Gestión de cobranza'),
//             t('Análisis de crédito'),
//             t('Core Bancario'),
//             t('Automatización de procesos'),
//             t('Procesos digitales'),
//             t('Producto financiero'),
//             t('Servicios financieros'),
//             t('Digitalización de procesos'),
//             t('Software financiero'),
//             t('Dispersión'),
//             t('Reportes automatizados'),
//             t('Corebanking'),
//             t('Sector financiero'),
//             t('SOFIPO'),
//             t('SOFOM'),
//             t('CNBV'),
//             t('Condusef'),
//             t('Servicios financieros digitales'),
//             t('Plataforma financiera'),
//           ].join(',')}
//         />
//         {/* <meta
//           name="robots"
//           content="INDEX, FOLLOW, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1, MAX-IMAGE-PREVIEW:LARGE"
//         />
//         <meta name="author" content={'Dynamicore'} />
//         <link
//           rel="canonical"
//           href={`https://dynamicore.io/${
//             i18n.language === 'en' ? 'en/collections' : 'cobranza'
//           }`}
//         />
//         <link
//           rel="alternate"
//           href="https://dynamicore.io/cobranza"
//           hreflang="es"
//         />
//         <link
//           rel="alternate"
//           href="https://dynamicore.io/en/collections"
//           hreflang="en"
//         />
//         <script src="https://www.googletagmanager.com/gtag/js?id=AW-10979614629"></script>
//         <script>
//           {`
//           window.dataLayer = window.dataLayer || [];
//           function gtag(){dataLayer.push(arguments);}
//           gtag('js', new Date());
//           gtag('config', 'AW-10979614629');
//         `}
//         </script>
//         <script>
//           {`
//           gtag('event', 'conversion', {'send_to': 'AW-10979614629/hJ5gCMCPpZgYEKW_vvMo'});
//         `}
//         </script>
//         <script>
//           {`
//           (function(h,o,t,j,a,r){
//               h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
//               h._hjSettings={hjid:3476732,hjsv:6};
//               a=o.getElementsByTagName('head')[0];
//               r=o.createElement('script');r.async=1;
//               r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
//               a.appendChild(r);
//           })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
//         `}
//         </script>

//         <script>
//           {`
//           (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//           new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//           j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//           'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//           })(window,document,'script','dataLayer','GTM-NXK7DRW');
//         `}
//         </script> */}
//       </Helmet>

//       <CobranzaPage />
//     </Layout>
//   );
// };
